export const types = {
    
    login: '[Auth] Login',
    logout: '[Auth] Logout',

    msgSetError: '[Msg] Set Errot',
    msgRemoveError: '[Msg] Set Error',

    dataLineChart: '[DataLineChart]',  
    
    dataDonutChart: '[DataDonutChart]'
}